<template>
  <div
    style="
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 3mm;
    page-break-before: always;
    "
  >
    <tiss-box
      title="GUIA DE OUTRAS DESPESAS"
      :logo="logoURL"
      :operadora="logoText"
      v-if="spsadt != null"
    >
      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="1 - Registro ANS"
          largura="15%"
          :value="registroANS"
        />
        <tiss-field
          title="2 - Número da Guia Referenciada"
          largura="20%"
          :value="numeroGuia"
        />
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados do Contratado Executante"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="3 - Código na Operadora "
          largura="25%"
          :value="codigoPrestadorNaOperadoraExecutante"
        />
        <tiss-field
          title="4 - Nome do Contratado"
          largura="52%"
          :value="nomeContratadoExecutante"
        />
        <tiss-field title="5 - Código CNES" largura="19.6%" :value="cnes" />
      </div>

      <!-- TABELA -->
      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Código de Despesas Realizadas CD = 1 - Gases Medicinais, 2 - Medicamentos, 3 - Materiais, 5 - Diárias, 7 - Taxas e Aluguéis, 8 - OPME"
          ></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 2px;">
        <div
          class="tiss-field mx-1 mt-1"
          :style="{ width: '98%', height: '13cm' }"
          style="
            border-style: solid;
            border-width: 1px;
            -webkit-print-color-adjust: exact;"
        >
          <div class="ml-2 font-weigh-normal" style="font-size: 6pt;">
            <!-- Table -->
            <table>
              <thead>
                <tr class="font-weight-normal" style="font-size: 7pt;">
                  <th style="width: 0.5cm;"></th>
                  <th style="width: 1cm;">6-CD</th>
                  <th style="width: 2cm;">7-Data</th>
                  <th style="width: 2cm;">8-Hora Inicial</th>
                  <th style="width: 2cm;">9-Hora Final</th>
                  <th style="width: 2cm;">10-Tabela</th>
                  <th style="width: 3cm;;">11-Código Item</th>
                  <th style="width: 2.5cm;">12-Quantidade</th>
                  <th style="width: 3cm;">13-Unidade Medida</th>
                  <th style="width: 3cm; text-align: right;">
                    14-%Red./Acresc.
                  </th>
                  <th style="width: 3cm; text-align: right;">
                    15-Valor Unitário
                  </th>
                  <th style="width: 3cm; text-align: right;">16-Valor Total</th>
                </tr>
                <tr class="font-weight-normal" style="font-size: 7pt;">
                  <th></th>
                  <th></th>
                  <th style="text-align: center;" colspan="3">
                    17-Registro ANVISA do Material
                  </th>
                  <th style="text-align: center;" colspan="3">
                    18-Referência do Material Fabricado
                  </th>
                  <th style="text-align: center;" colspan="3">
                    19-Número Autorização de Funcionamento
                  </th>
                  <th style="text-align: center;" colspan="3">
                    28-Centro Consumo
                  </th>
                </tr>
                <tr>
                  <th>&nbsp;</th>
                  <th></th>
                  <th style="text-align: center;" colspan="3"></th>
                  <th style="text-align: center;" colspan="3"></th>
                  <th style="text-align: center;" colspan="3"></th>
                </tr>
              </thead>

              <tbody>
                <template v-for="(despesa, index) in outrasDespesas">
                  <tr
                    class="font-weight-bold"
                    style="font-size: 8pt;"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ despesa.codigoDespesa }}</td>
                    <td>
                      {{
                        despesa.servicosExecutados.dataExecucao
                          ? $util.getFormatDate(
                              despesa.servicosExecutados.dataExecucao,
                              "DD/MM/YYYY"
                            )
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        despesa.servicosExecutados.horaInicial
                          ? formatarHora(
                              despesa.servicosExecutados.horaInicial,
                              "HH:mm:ss"
                            )
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        despesa.servicosExecutados.horaFinal
                          ? formatarHora(
                              despesa.servicosExecutados.horaFinal,
                              "HH:mm:ss"
                            )
                          : ""
                      }}
                    </td>
                    <td>{{ despesa.servicosExecutados.codigoTabela }}</td>
                    <td>{{ despesa.servicosExecutados.codigoProcedimento }}</td>
                    <td>
                      {{ $util.formatMoeda(despesa.servicosExecutados.quantidadeExecutada, 3, 0) }}
                    </td>
                    <td>{{ despesa.servicosExecutados.unidadeMedida }}</td>
                    <td style="text-align: right; padding-right: 10px">
                      {{
                        despesa.servicosExecutados.reducaoAcrescimo
                          ? $util.formatMoeda(
                              despesa.servicosExecutados.reducaoAcrescimo
                            )
                          : ""
                      }}
                    </td>
                    <td style="text-align: right; padding-right: 10px">
                      {{
                        !ocultar_valores() && despesa.servicosExecutados.valorUnitario
                          ? $util.formatMoeda(
                              despesa.servicosExecutados.valorUnitario
                            )
                          : ""
                      }}
                    </td>
                    <td style="text-align: right; padding-right: 10px">
                      {{
                        !ocultar_valores() && despesa.servicosExecutados.valorTotal
                          ? $util.formatMoeda(
                              despesa.servicosExecutados.valorTotal
                            )
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr
                    class="font-weight-bold"
                    style="border-bottom: 1px solid gainsboro"
                    :key="'A' + index"
                  >
                    <td></td>
                    <td style="font-size: 8pt;" colspan="10">
                      {{
                        "20 - Descrição: " +
                          despesa.servicosExecutados.descricaoProcedimento
                      }}
                    </td>
                    <td
                      style="
                        font-size: 8pt;
                        width: 3cm;
                        max-width: 3cm;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      :title="despesa.servicosExecutados.centroConsumo || ''"
                    >
                      {{
                        despesa.servicosExecutados.centroConsumo
                          ? despesa.servicosExecutados.centroConsumo
                          : ""
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- TOTAIS -->

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="21 - Total Gases Medicinais"
          largura="14%"
          :value="valorGasesMedicinais"
        />
        <tiss-field
          title="22 - Total Medicamentos"
          largura="14%"
          :value="valorMedicamentos"
        />
        <tiss-field
          title="23 - Total Materiais"
          largura="14%"
          :value="valorMateriais"
        />
        <tiss-field title="24 - Total OPME" largura="14%" :value="valorOPME" />
        <tiss-field
          title="25 - Total Taxas e Aluguéis"
          largura="14%"
          :value="valorTaxasAlugueis"
        />
        <tiss-field
          title="26 - Total Diárias"
          largura="14%"
          :value="valorDiarias"
        />

        <tiss-field
          title="27 - Total Geral"
          largura="9.8%"
          :value="valorGeral"
        />
      </div>
      <div class="row">
        <div class="col">
          <tiss-rodape
            :infoId="this.guia.id_atendimento"
            :idExterno="this.guia.st_id_externo"
            :responsavel="atendimento_usuario()"
          ></tiss-rodape>
        </div>
      </div>
    </tiss-box>
  </div>
</template>

<script>
// import _ from "lodash";
import * as moment from "moment";
// import TissTable from "./TissTable.vue";
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
import TissRodape from "./TissRodape";

export default {
  data() {
    return {
      largura: "21cm",
      larguramm: 200
    };
  },
  methods: {
    atendimento_usuario() {
      if (this.guia && this.guia.st_login) {
        return this.guia.st_login;
      }

      return null;
    },

    clargura(perc = 100) {
      let larg = this.larguramm - 20;
      larg = Math.round(larg * (perc / 100));
      return larg + "mm";
    },
    formatarHora: function(valor, formato) {
      return moment(valor, formato).format("HH:mm");
    },
    ocultar_valores() {
        return this.guia && this.guia.ocultar_valores;
    }
  },
  computed: {
    spsadt: function() {
      if (this.guia != null && this.guia.mensagemTISS != null) {
        return this.guia.mensagemTISS;
      }
      return null;
    },
    logoURL: function() {
      if (this.guia && this.guia.logo_url_front) {
        return this.guia.logo_url_front;
      }

        if (this.guia && this.guia.logo_text_front) {
            return null;
        }

      return this.logo
    },
    logoText: function() {
        if (this.guia && this.guia.logo_text_front) {
            return this.guia.logo_text_front;
        }

        return this.operadora ? this.operadora.search : '';
    },
    valorPago() {
      let valor = {};
      if (
        Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .valorTotal
        )
      ) {
        valor = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          this.nomeGuia
        ].valorTotal[0];
      } else
        valor = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          this.nomeGuia
        ].valorTotal;
      return valor;
    },
    registroANS: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .cabecalhoGuia.registroANS
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          this.nomeGuia
        ].cabecalhoGuia.registroANS;
      else return "";
    },
    numeroGuia: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .cabecalhoGuia.numeroGuiaPrestador
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          this.nomeGuia
        ].cabecalhoGuia.numeroGuiaPrestador;
      else return "";
    },
    numeroGuiaOperadora: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .numeroGuiaOperadora
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          this.nomeGuia
        ].numeroGuiaOperadora;
      else return "";
    },
    codigoPrestadorNaOperadoraExecutante: function() {
      let txt = "";

      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .dadosExecutante.contratadoExecutante
      ) {
        if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.CNPJ
        )
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            this.nomeGuia
          ].dadosExecutante.contratadoExecutante.CNPJ;
        else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.codigoPrestadorNaOperadora
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            this.nomeGuia
          ].dadosExecutante.contratadoExecutante.codigoPrestadorNaOperadora;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.CPF
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            this.nomeGuia
          ].dadosExecutante.contratadoExecutante.CPF;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.cpfContratado
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            this.nomeGuia
          ].dadosExecutante.contratadoExecutante.cpfContratado;
        } else if (
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.cnpjContratado
        ) {
          txt = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            this.nomeGuia
          ].dadosExecutante.contratadoExecutante.cnpjContratado;
        }
      }
      return txt;
    },
    nomeContratadoExecutante: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .dadosExecutante.contratadoExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .dadosExecutante.contratadoExecutante.nomeContratado
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.contratadoExecutante.nomeContratado
        : "";
    },
    cnes: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].dadosExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .dadosExecutante.CNES
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
            .dadosExecutante.CNES
        : "";
    },
    valorProcedimentos: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorProcedimentos
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorProcedimentos
          )
        : "";
    },
    valorDiarias: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorDiarias
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorDiarias
          )
        : "";
    },
    valorTaxasAlugueis: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorTaxasAlugueis
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorTaxasAlugueis
          )
        : "";
    },
    valorMateriais: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorMateriais
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorMateriais
          )
        : "";
    },
    valorMedicamentos: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorMedicamentos
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorMedicamentos
          )
        : "";
    },
    valorOPME: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorOPME
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorOPME
          )
        : "";
    },
    valorGasesMedicinais: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        this.nomeGuia
      ].valorTotal &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal.valorGasesMedicinais
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              this.nomeGuia
            ].valorTotal.valorGasesMedicinais
          )
        : "";
    },
    valorGeral: function() {
      var total = Number(0);

      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
          .valorTotal
      ) {
        var totalGeralXML = this.spsadt.prestadorParaOperadora.loteGuias
          .guiasTISS[this.nomeGuia].valorTotal;

        if (totalGeralXML.valorGasesMedicinais)
          total += Number(totalGeralXML.valorGasesMedicinais);

        if (totalGeralXML.valorMedicamentos)
          total += Number(totalGeralXML.valorMedicamentos);

        if (totalGeralXML.valorMateriais)
          total += Number(totalGeralXML.valorMateriais);

        if (totalGeralXML.valorOPME) total += Number(totalGeralXML.valorOPME);

        if (totalGeralXML.valorTaxasAlugueis)
          total += Number(totalGeralXML.valorTaxasAlugueis);

        if (totalGeralXML.valorDiarias)
          total += Number(totalGeralXML.valorDiarias);
      }

      return !this.ocultar_valores() ? this.$util.formatMoeda(total) : '';
    },
    // outrasDespesas: function() {
    //   let array = [];
    //   if (
    //     !Array.isArray(
    //       this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[this.nomeGuia]
    //         .outrasDespesas.despesa
    //     )
    //   ) {
    //     array[0] = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
    //       this.nomeGuia
    //     ].outrasDespesas.despesa;
    //   } else
    //     array = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
    //       this.nomeGuia
    //     ].outrasDespesas.despesa;
    //   return _.orderBy(array, "codigoDespesa");
    // },
    tabelaOutrasDespesas: function() {
      let campos = [];
      let despesas = this.outrasDespesas;

      for (let i = 0; i < despesas.length; i++) {
        let tmp = {};

        if (despesas[i].codigoDespesa) {
          tmp["CD"] = despesas[i].codigoDespesa;
        } else tmp["CD"] = "";

        if (despesas[i].servicosExecutados.dataExecucao) {
          tmp["Data"] = this.$util.getFormatDate(
            despesas[i].servicosExecutados.dataExecucao,
            "DD/MM/YYYY"
          );
        } else tmp["Data"] = "";

        if (despesas[i].servicosExecutados.horaInicial)
          tmp["Hora Inicial"] = moment(
            despesas[i].servicosExecutados.horaInicial,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Inicial"] = "";

        if (despesas[i].servicosExecutados.horaFinal)
          tmp["Hora Final"] = moment(
            despesas[i].servicosExecutados.horaFinal,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Final"] = "";

        if (despesas[i].servicosExecutados.codigoTabela)
          tmp["Tabela"] = despesas[i].servicosExecutados.codigoTabela;
        else tmp["Tabela"] = "";

        if (despesas[i].servicosExecutados.codigoProcedimento)
          tmp["Codigo do item"] =
            despesas[i].servicosExecutados.codigoProcedimento;
        else tmp["Codigo do item"] = "";

        if (despesas[i].servicosExecutados.quantidadeExecutada)
          tmp["Quantidade"] =
            despesas[i].servicosExecutados.quantidadeExecutada;
        else tmp["Quantidade"] = "";

        if (despesas[i].servicosExecutados.unidadeMedida)
          tmp["Unidade de Medida"] =
            despesas[i].servicosExecutados.unidadeMedida;
        else tmp["Unidade de Medida"] = "";

        if (despesas[i].servicosExecutados.reducaoAcrescimo)
          tmp["%Red./Acresc."] = this.$util.formatMoeda(
            despesas[i].servicosExecutados.reducaoAcrescimo
          );
        else tmp["%Red./Acresc."] = "";

        if (despesas[i].servicosExecutados.valorUnitario)
          tmp["Valor Unitario"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            despesas[i].servicosExecutados.valorUnitario
          ) : tmp["Valor Unitario"] = "";
        else tmp["Valor Unitario"] = "";

        if (despesas[i].servicosExecutados.valorTotal)
          tmp["Valor Total"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            despesas[i].servicosExecutados.valorTotal
          ) : tmp["Valor Total"] = "";
        else tmp["Valor Total"] = "";

        campos.push(tmp);
      }

      return campos;
    },
    tabelaOutrasDespesasL2: function() {
      let campos = [];
      let despesas = this.outrasDespesas;
      for (let i = 0; i < despesas.length; i++) {
        let tmp = {};

        if (despesas[i].servicosExecutados.descricaoProcedimento) {
          tmp["Descrição"] =
            despesas[i].servicosExecutados.descricaoProcedimento;
        } else tmp["Descrição"] = "";

        campos.push(tmp);
      }

      return campos;
    },
    headerLinha2: function() {
      return (
        "17 - Registro ANVISA do Material &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "18 -  Referência do Material Fabricado  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "19 -  Número Autorização de Funcionamento "
      );
    },

    styleRotate() {
      if (this.rotate)
        return "transform: rotate(270deg) translate(-376mm, 0); transform-origin: 0 0; margin: 0; padding: 0;";
      //return "-webkit-transform: rotate(-90deg) !important;-moz-transform:rotate(-90deg) !important;-o-transform: rotate(-90deg) !important; -ms-transform:rotate(-90deg) !important;position:relative;top:15cm;left:0px; padding:1cm;";
      //return "-webkit-transform: rotate(-90deg) scale(.65,.65) !important;-moz-transform:rotate(-90deg) scale(.58,.58)!important;-o-transform: rotate(-90deg) scale(.58,.58)!important; -ms-transform:rotate(-90deg) scale(.6,.6)!important;position:relative;top:10cm;left:0px; padding:1cm;";
      return "";
    }
  },
  props: ["guia", "operadora", "logo", "rotate", "outrasDespesas", "nomeGuia"],
  components: {
    TissBox,
    TissField,
    TissSubTitle,
    TissRodape
  }
};
</script>

<style></style>
